import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const facultyApi = generateNomenApi<{ name: string }>(`/faculties`); // TODO SEPARATE faculty from nomen

export const facultyOptions = generateNomenOptions('faculty', facultyApi);
